import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";
// import { convertToBgImage } from "gbimage-bridge";
// import BackgroundImage from "gatsby-background-image";
import Btn, { Btn2 } from "../../common/btn";

const HeroMobile = ({ data }) => {
  //   const bgImgMobile = convertToBgImage(
  //     data.bgImageMobile.asset.gatsbyImageData
  //   );

  const color = data.textColor.hex;

  // Add overlay styling based on bgOverlay data
  const overlayStyle = data.bgOverlay?.rgb
    ? {
        backgroundColor: `rgba(${data.bgOverlay.rgb.r}, ${data.bgOverlay.rgb.g}, ${data.bgOverlay.rgb.b}, ${data.bgOverlay.rgb.a})`,
      }
    : null;

  return (
    <div className="w-full h-[550px] relative bg-cover bg-right-top">
      {/* Background Image Container */}
      <div className="absolute inset-0 w-full h-full">
        <GatsbyImage
          image={data.bgImageMobile.asset.gatsbyImageData}
          alt=""
          objectFit="cover"
          objectPosition="center"
          loading="eager"
          className="w-full h-full"
        />
      </div>

      {/* Overlay */}
      <div
        className="w-full h-full absolute inset-0 z-[1]"
        style={
          overlayStyle || {
            background:
              "linear-gradient(to bottom left, rgba(0,0,0,0.3), rgba(255,255,255,0.15))",
          }
        }
      ></div>

      {/* Content Container */}
      <div className="relative h-full w-full flex flex-col items-center justify-between pb-[37px] z-10">
        {/* Text Content */}
        <div className="w-full px-[18px] pt-[68px] text-center">
          <h1
            className="block text-[40px] font-bold leading-[1.2] relative"
            style={{ color: `${color}` }}
          >
            {data.title}
          </h1>
          {data.mobileSubTitle && (
            <p
              className="block text-lg leading-6 mt-5 text-center relative"
              style={{ color: `${color}` }}
            >
              {data.mobileSubTitle}
            </p>
          )}
        </div>

        {/* Button */}
        {data.button?.buttonText && (
          <div className="relative mt-10 mb-5">
            <Btn2 data={data.button} />
          </div>
        )}
      </div>
    </div>
  );
};

export default HeroMobile;

export const HeroVideoMobile = ({ data }) => {
  const color = data.textColor.hex;

  // Add overlay styling based on bgOverlay data
  const overlayStyle = data.bgOverlay?.rgb
    ? {
        backgroundColor: `rgba(${data.bgOverlay.rgb.r}, ${data.bgOverlay.rgb.g}, ${data.bgOverlay.rgb.b}, ${data.bgOverlay.rgb.a})`,
      }
    : null;

  return (
    <div
      className="w-full h-[550px] relative bg-cover bg-right-top flex flex-col items-center"
      style={{ justifyContent: "space-between", paddingBottom: "37px" }}
    >
      <div className="absolute top-0 right-0 bottom-0 left-0 w-full h-full z-0">
        <video
          src={data.video.asset.url}
          autoPlay
          muted
          loop
          playsInline
          webkit-playsinline="true"
          preload="auto"
          className="object-cover w-full h-full"
          controls={false}
          style={{
            pointerEvents: "none",
          }}
        ></video>
      </div>

      {/* Overlay */}
      <div
        className="w-full h-full absolute inset-0 z-[1]"
        style={
          overlayStyle || {
            background:
              "linear-gradient(to bottom left, rgba(0,0,0,0.3), rgba(255,255,255,0.15))",
          }
        }
      ></div>

      <div className="relative z-10 text-center w-full px-[18px] pt-[68px]">
        <h1
          className="block text-[40px] font-bold leading-[1.2]"
          style={{ color: `${color}` }}
        >
          {data.title}
        </h1>
        {data.subTitle && (
          <p
            className="block text-lg leading-6 mt-5 text-center"
            style={{ color: `${color}` }}
          >
            {data.subTitle}
          </p>
        )}
      </div>
      {data.button?.buttonText && (
        <div className="relative mt-10 mb-5 z-10">
          <Btn2 data={data.button} />
        </div>
      )}
    </div>
  );
};
